const PDS_API_BASE_URL = '/service/pds';

export const apiRoutes = {
  setLimits: () => `${PDS_API_BASE_URL}/v1/responsible_gambling/set_limits`,
  getLimits: () => `${PDS_API_BASE_URL}/v1/responsible_gambling/get_limits`
};
